import { RdcConsignmentsApiService } from 'core/api';
import { IRdcConsignmentDao } from 'core/api/types/rdc.interface';
import { useEffect, useState } from 'react';
import SkeletonElement from 'shared/components/layout/skeleton-element';

interface IRdcOverviewPhotos {
  consignment: IRdcConsignmentDao;
}

const RdcOverviewPhotos = ({ consignment }: IRdcOverviewPhotos) => {
  const [urls, setUrls] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const prepare = async () => {
      try {
        const settled = await Promise.allSettled(
          (consignment.photoPaths ?? []).map((path) => RdcConsignmentsApiService.getPhotoUrl(path))
        );
        setUrls(
          settled
            .filter((result): result is PromiseFulfilledResult<string> => result.status === 'fulfilled')
            .map((result) => result.value)
        );
      } finally {
        setLoading(false);
      }
    };
    if (consignment.photoPaths?.length) {
      prepare();
    } else {
      setLoading(false);
    }
  }, [consignment.photoPaths]);

  return (
    <div className='bg-white rounded-md shadow-md'>
      <div className='flex justify-between items-center p-4 border-b'>
        <p className='headline-06'>Photos</p>
      </div>
      <div className='p-4'>
        {loading && <SkeletonElement width='340px' height='340px' />}
        {!loading && urls.length === 0 && <p className='text-stone-300'>No photos for this consignment</p>}
        {!loading && urls.length > 0 && (
          <div className='flex flex-wrap gap-4'>
            {urls.map((url, index) => (
              <img key={index} className='max-h-[340px] rounded-md' src={url} alt={`Consignment ${index + 1}`} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default RdcOverviewPhotos;
